type Props = {}
const TournamentGroupDetails = (props:Props) => {
    return <></>
}

export default TournamentGroupDetails